import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CapturumNotificationBadgeComponent } from './notification-badge.component';

@NgModule({
  declarations: [
    CapturumNotificationBadgeComponent
  ],
  exports: [
    CapturumNotificationBadgeComponent
  ],
  imports: [
    CommonModule
  ]
})
export class CapturumNotificationBadgeModule {
}
